import PoetAllInfoGallery from './PoetAllInfoGallery.jsx';

import 'react-image-gallery/styles/css/image-gallery.css';
import './poet-all-info-gallery.scss';

export default PoetAllInfoGallery;
